// Types
import * as Types from '../types'
import { requestActionProps, requestGenerate } from '../../common'
import api from '../../../services/api'
import { callbackProps } from '../../../constants'

const actionGetStoryQuestions = (
  payload:any,
  callback?: (a: callbackProps) => void
): requestActionProps => ({
  type: requestGenerate(Types.REQUEST),
  api: api.getStoryQuestions,
  payload: { data: new URLSearchParams(payload) },
  callback,
});

export {
    actionGetStoryQuestions,
};